import { RhumbProvider } from 'react-rhumb';
import { createBrowserHistory } from 'history';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import rhumbConfig from '../../rhumb-config.yaml';
import { ProvideDataFetchingClient } from './dataFetchingClient/DataFetchingClientProvider';
import ApolloProviderContainer from './graphQL/ApolloProviderContainer';
import Router from './Router';
import { provideReferenceResolvers } from './utils/provideReferenceResolvers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getRootPathFromWindow = () => {
  const hubspotBasePathnameRegex = /^\/[\w-]+\/\d+/;
  const parts = window.location.pathname.match(hubspotBasePathnameRegex);
  return parts ? parts[0] : undefined;
};
export function AppContainer() {
  // Compute the basename from the current URL since we still handle legacy `/contacts/PORTAL/tasks` paths
  const history = createBrowserHistory({
    basename: getRootPathFromWindow()
  });
  return /*#__PURE__*/_jsx(RhumbProvider, {
    config: rhumbConfig,
    history: historyAdapter(history),
    children: /*#__PURE__*/_jsx(ApolloProviderContainer, {
      children: /*#__PURE__*/_jsxs(ProvideDataFetchingClient, {
        children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Router, {
          history: history
        })]
      })
    })
  });
}
export default provideReferenceResolvers(AppContainer);